import Client from './Client'
import { Error } from './Error'

export default class Proovers extends Client {
  async fetchProovers(token, payload) {
    try {
      const query =  {
        find: payload.search,
        offset: payload.offset,
        limit: payload.limit
      }
      return await this.request(token, 'get', 'proover', null, query)
    } catch (error) {
      throw new Error(error)
    }
  }
}
